import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { swapViewColumn } from "@design-system/ViewTable/swapViewColumn";
import { HistoryTransactionDetailsColumn } from "./historyTransactionDetailsView";
import { HistoryCreatedTransactionColumn } from "./historyCreatedTransactionDetailsViewConfig";

export const defaultHistoryTransactionDetailsView: View = {
    type: ViewType.HISTORY_UPDATED_TRANSACTION,
    columns: [
        {
            id: HistoryTransactionDetailsColumn.LOG_TIME,
            options: { pin: "left" },
        },
        { id: HistoryTransactionDetailsColumn.DATE },
        { id: HistoryTransactionDetailsColumn.DESCRIPTION },
        { id: HistoryTransactionDetailsColumn.OLD_VALUE },
        { id: HistoryTransactionDetailsColumn.NEW_VALUE },
        { id: HistoryTransactionDetailsColumn.FINANCIAL_ACCOUNT },
        { id: HistoryTransactionDetailsColumn.AMOUNT },
        {
            id: HistoryTransactionDetailsColumn.ENTITY,
            options: { pin: "right" },
        },
        {
            id: HistoryTransactionDetailsColumn.ACTIONS,
            options: { pin: "right" },
        },
    ],
    filters: {},
    options: {
        bulkActions: true,
        selection: true,
        density: ViewDensity.MD,
    },
};

const createDefaultHistoryCreatedTransactionDetailsView = (
    classificationColumnId: HistoryCreatedTransactionColumn,
): View => ({
    type: ViewType.HISTORY_CREATED_TRANSACTION,
    columns: [
        {
            id: HistoryCreatedTransactionColumn.LOG_TIME,
            options: { pin: "left" },
        },
        { id: HistoryCreatedTransactionColumn.DATE },
        { id: HistoryCreatedTransactionColumn.BANK_DESCRIPTION },
        { id: classificationColumnId },
        { id: HistoryCreatedTransactionColumn.ACCOUNT },
        { id: HistoryCreatedTransactionColumn.AMOUNT },
        { id: HistoryCreatedTransactionColumn.ENTITY },
        { id: HistoryCreatedTransactionColumn.ACTIONS },
    ],
    filters: {},
    options: {
        bulkActions: true,
        selection: true,
        density: ViewDensity.MD,
    },
});

export const createGlFirstDefaultHistoryCreatedTransactionDetailsView =
    (): View =>
        createDefaultHistoryCreatedTransactionDetailsView(
            HistoryCreatedTransactionColumn.LEDGER,
        );

export const createCategoryFirstDefaultHistoryCreatedTransactionDetailsView =
    (): View =>
        createDefaultHistoryCreatedTransactionDetailsView(
            HistoryCreatedTransactionColumn.CATEGORY,
        );

export const withGlFirstLedgerColumn = (
    view: View,
    isGlFirst: boolean,
): View => {
    const fromColumnId = isGlFirst
        ? HistoryCreatedTransactionColumn.CATEGORY
        : HistoryCreatedTransactionColumn.LEDGER;
    const toColumnId = isGlFirst
        ? HistoryCreatedTransactionColumn.LEDGER
        : HistoryCreatedTransactionColumn.CATEGORY;

    return {
        ...view,
        columns: swapViewColumn(view.columns, {
            fromColumnId,
            toColumnId,
            createTargetColumn: (column) => ({ ...column, id: toColumnId }),
        }),
    };
};
